import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
// Hanken Grotesk -- the platform's typeface.
//
// Carefull's brand font is Cerebri Sans Pro, which is not shipped here: the licensed files
// in the workspace's branding/ folder are desktop .ttf/.otf, and a desktop licence does not
// cover web embedding. Hanken Grotesk is by the same foundry (Hanken Design Co.), carries
// the same geometric-humanist proportions as the wordmark, and is OFL -- so it can be
// self-hosted and served to every clinic without a licence question.
//
// Self-hosted via @fontsource rather than the Google CDN: no third-party request from an
// EU clinic app, and no flash of unstyled text.
import '@fontsource/hanken-grotesk/300.css';
import '@fontsource/hanken-grotesk/400.css';
import '@fontsource/hanken-grotesk/500.css';
import '@fontsource/hanken-grotesk/600.css';
import '@fontsource/hanken-grotesk/700.css';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import { BrandingProvider } from './contexts/BrandingContext';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { AppLocalizationProvider } from './components/layout/localizationProvider';
import { SnackbarProvider } from './components/layout/snackbarProvider';
import "./i18n";

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 0, // 2 minutes
            gcTime: 1000 * 60 * 30,   // 30 minutes
            retry: 1,
            refetchOnWindowFocus: true,
            refetchOnReconnect: true,
        }
    }
});

root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}> {/** extract to a different componenet */}
            {/* Branding sits below auth, which tells it whether there is a clinic to ask
                about, and above App, which holds the ThemeProvider it feeds. */}
            <AuthProvider>
                <BrandingProvider>
                    <SnackbarProvider>
                        {/* Innermost, so the pickers' locale follows the language the
                            header picker sets rather than the browser's. */}
                        <AppLocalizationProvider>
                            <App />
                        </AppLocalizationProvider>
                    </SnackbarProvider>
                </BrandingProvider>
            </AuthProvider>
        </QueryClientProvider>
    </React.StrictMode>
);

reportWebVitals();